module.exports = __webpack_public_path__ + "static/media/chi.bb13a002.png";